import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { DataContext } from "../Context/Context";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  stepOne: {
    ["@media (min-width:1024px)"]: {
      backgroundColor: "rgb(252, 255, 255)",
      border: "1px solid #00cccc",
      borderRadius: 4,
      padding: 20,
      marginTop: 10,
    },
  },
  logo: {
    width: "40%",
  },
  title: {
    textTransform: "uppercase",
  },
  amountInput: {
    marginTop: 30,
    width: "80%",
  },
  addBtn: {
    color: "white",
    fontWeight: "bold",
    width: "80%",
    margin: "230px auto 0 auto",
    textTransform: "uppercase",
    backgroundColor: "#6200ee",
    "&:hover": {
      backgroundColor: "#6200ee",
    },
  },
}));

export default function WizardStepOne() {
  const classes = useStyles();
  const history = useHistory();

  const { inputAmount, setInputAmount } = useContext(DataContext);

  const onSubmit = (event) => {
    event.preventDefault();

    history.push("/wizardsteptwo");
  };

  return (
    <div className={classes.stepOne}>
      <img
        className={classes.logo}
        src={require("../images/logo-text.png").default}
        alt="logo"
      />
      <h1 className={classes.title}>Welcome</h1>
      <p>How much money you have at the moment?</p>
      <form onSubmit={onSubmit}>
        <TextField
          type="number"
          onChange={(e) => setInputAmount(e.target.value)}
          className={classes.amountInput}
          value={inputAmount}
          label="Amount"
          helperText="Please insert your amount"
          variant="filled"
        ></TextField>
        <Button
          type="submit"
          className={classes.addBtn}
          variant="contained"
          disabled={inputAmount === "" || inputAmount <= 0}
          color="primary"
        >
          Add
        </Button>
      </form>
    </div>
  );
}
